import React from 'react';
import AuthenticatedHeader from '../components/header/AuthenticatedHeader';
import { Outlet } from 'react-router-dom';

interface LayoutProps {}

const Layout: React.FC<LayoutProps> = () => (
  <>
    <AuthenticatedHeader />
    <main><Outlet /></main>
  </>
);

export default Layout;